<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<blockquote class="sink">
<p class="center "><em>Dedicated to Joe Dignan</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?98539ea0